import React from 'react';
import './Pages.css';

function Home() {
  return (
    <div className="page-container">
      <div className="hero-section">
        <div className="hexagon-icon">🔷</div>
        <h1 className="page-title">六边形贪吃蛇</h1>
        <p className="subtitle">HexaSnake Hive</p>
        <p className="description">
          创新六边形网格玩法，挑战你的策略思维
        </p>
      </div>

      <div className="content-card">
        <h2>✨ 游戏特色</h2>
        <div className="features-grid">
          <div className="feature-item">
            <div className="feature-icon">🔷</div>
            <h3>创新六边形网格</h3>
            <p>突破传统正方形网格限制，六个方向自由移动</p>
          </div>
          <div className="feature-item">
            <div className="feature-icon">⚡</div>
            <h3>加速模式</h3>
            <p>按住加速按钮体验极速挑战，更高的技巧要求</p>
          </div>
          <div className="feature-item">
            <div className="feature-icon">🎯</div>
            <h3>直观操控</h3>
            <p>六个方向按钮，操作简单明了，完美适配横屏</p>
          </div>
          <div className="feature-item">
            <div className="feature-icon">📊</div>
            <h3>记录追踪</h3>
            <p>实时显示得分，自动保存最高分记录</p>
          </div>
          <div className="feature-item">
            <div className="feature-icon">🎨</div>
            <h3>简约设计</h3>
            <p>黑色背景配合鲜明色彩，专注游戏体验</p>
          </div>
          <div className="feature-item">
            <div className="feature-icon">🆓</div>
            <h3>完全免费</h3>
            <p>无内购、无广告、无需注册，纯粹的游戏体验</p>
          </div>
        </div>
      </div>

      <div className="content-card">
        <h2>🎮 游戏玩法</h2>
        <ol className="gameplay-list">
          <li><strong>移动蛇身</strong>：点击六个方向按钮之一改变移动方向</li>
          <li><strong>收集食物</strong>：吃到红色食物后蛇身会增长，得分增加</li>
          <li><strong>避免碰撞</strong>：不要撞到自己的身体或网格边界</li>
          <li><strong>加速冲刺</strong>：按住中央加速按钮体验极速模式</li>
          <li><strong>挑战高分</strong>：不断突破自己的最高纪录</li>
        </ol>
      </div>

      <div className="content-card">
        <h2>📱 下载游戏</h2>
        <p className="download-text">
          在 App Store 搜索"六边形贪吃蛇"或"HexaSnake Hive"即可下载！
        </p>
        <div className="download-badges">
          <div className="badge-placeholder">
            <span>📱</span>
            <p>App Store 即将上线</p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Home;
